import { Global } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../components/SeoHead';
import MainBanner from '../../components/MainBanner';
import SimpleContent from '../../components/SimpleContent';

export default function SubmissionSuccess({
    global,
}) {
    return (
        <>
            <SeoHead
                robots='noindex, folow'
                page_name={`Submission Success | The global house of tech and transformation recruitment | Lorien`}
                canonical_link={`submission-success`}
                en_gb={false}
                en_us={true}
            />
            <MainBanner
                global={global}
                pathPrefix={`us.submission_success_page.main_banner`}
                customClass={``}
                content={
                    <>
                        <h1>Submission Success</h1>
                    </>
                }
                imageURL1={`/site-assets/images/main-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
                imageALT2={`Overlay Main Banner`}
                displayImage1={false}
            />
            <SimpleContent
                global={global}
                pathPrefix={`us.submission_success_page.simple_content`}
                customClass={`py-5 text-center`}
                content={
                    <>
                        <p>Your submission has been successfully submitted.</p>
                        <p>We will be in touch shortly!</p>
                    </>}
                editableText={true}
                buttonTitle1={`Back to home`}
                buttonTitleLink1={`/us`}
            />
        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();

    return {
        props: {
            global,
        }
    };
}
